import { configureStore } from "@reduxjs/toolkit";
import categoryReducer from "./Slices/CategorySlice";
import BrandsReducer from "./Slices/BrandsSlice";
import SubCategoryReducer from "./Slices/SubCategorySlice";
import ProductReducer from "./Slices/ProductSlice";
import AuthReducer from "./Slices/AuthSlice";
import ReviewsReducer from "./Slices/ReviewsSlice";
import FavoriteReducer from "./Slices/FavoriteSlice";
import CouponReducer from "./Slices/CouponSlice";
import UserReducer from "./Slices/UserSlice";
import CartReducer from "./Slices/CartSlice";
import CheckOutReducer from "./Slices/CheckOutSlice";
import OrderReducer from "./Slices/OrderSlice";

export const store = configureStore({
  reducer: {
    CategoryReducer: categoryReducer,
    BrandsReducer: BrandsReducer,
    SubCategoryReducer: SubCategoryReducer,
    ProductReducer: ProductReducer,
    AuthReducer: AuthReducer,
    ReviewsReducer: ReviewsReducer,
    FavoriteReducer: FavoriteReducer,
    CouponReducer: CouponReducer,
    UserReducer: UserReducer,
    CartReducer: CartReducer,
    CheckOutReducer:CheckOutReducer,
    OrderReducer:OrderReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});
